import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
};

const WhatsAppReminderModal = ({ open, onOpenChange, tramite }: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      eventType="escrituras.recordatorio_firma_dia"
      title="Recordatorio de día de firma"
      description="Selecciona destinatarios, edita teléfonos, previsualiza el mensaje y confirma el envío."
    />
  );
};

export default WhatsAppReminderModal;
